import "@/App.css";
import Bundles from "@/pages/Bundles";
import BundleEditor from "@/pages/BundleEditor";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Layout } from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Library from "@/pages/Library";
import Studio from "@/pages/Studio";
import { useParams } from "react-router-dom";

const StudioRoute = () => <Studio key={useParams().id} />;
import Deliveries from "@/pages/Deliveries";
import Settings from "@/pages/Settings";
import Download from "@/pages/Download";
import StorePage from "@/pages/StorePage";
import Series from "@/pages/Series";
import WhatsNew from "@/pages/WhatsNew";

const Protected = ({ children }) => {
  const { user } = useAuth();
  if (user === null)
    return (
      <div className="min-h-screen flex items-center justify-center font-display text-2xl italic text-[#5C5255]">
        Opening the press…
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  return <Layout>{children}</Layout>;
};

function App() {
  return (
    <div className="App grain">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/download/:token" element={<Download />} />
            <Route path="/whats-new" element={<WhatsNew />} />
            <Route path="/store" element={<Protected><StorePage /></Protected>} />
            <Route path="/bundles" element={<Protected><Bundles /></Protected>} />
            <Route path="/bundles/:id" element={<Protected><BundleEditor /></Protected>} />
            <Route path="/series" element={<Protected><Series /></Protected>} />
            <Route path="/" element={<Protected><Dashboard /></Protected>} />
            <Route path="/library" element={<Protected><Library /></Protected>} />
            <Route path="/products/:id" element={<Protected><StudioRoute /></Protected>} />
            <Route path="/deliveries" element={<Protected><Deliveries /></Protected>} />
            <Route path="/settings" element={<Protected><Settings /></Protected>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="bottom-right" />
      </AuthProvider>
    </div>
  );
}

export default App;
